//This class serves as a request container for changes to an auction while the auction is live. Special care has to be taken to avoid conflicting auction modifications by locking the auction during such an operation.
export class HotEditRequest{
    public userId!:string;
    public businessId!:string;
    public auctionId!:number;
    public action!:string;
    public reservePrice?:number;
    public postponeEndDate?:string;
    public additionalInstructions?:string;
    public reason?:string;

}